<template>
    <div v-if="backdrop">
        <div
            class="modal fade"
            :class="modal.open ? 'show' : ''"
            style="display: block"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            @click="dismiss ? $event.target.classList.contains('modal') ? close() : true : true"
        >
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">{{config.title == null ? '&nbsp;' : config.title}}</h5>
                        <button type="button" class="close" @click="close()" v-html="loading ? spin() : ic('close')"/>
                    </div>

                    <div class="modal-body pt-3">

                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="principal" class="form-label">Principal</label>
                                <selectize
                                    id="principal"
                                    @input="_getListBrand"
                                    v-model="dataFilter.id_principal"
                                    data-placeholder="Pilih Principal"
                                    required
                                    :disabled="loading"
                                    :settings="selectizeConfig">
                                    <option :value="d.id" v-for="(d, i) in principals" :key="i"> {{d.nama_principal}}</option>
                                </selectize>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="brand" class="form-label">Brand</label>
                                <selectize
                                    id="brand"
                                    v-model="dataFilter.id_brand"
                                    data-placeholder="Pilih Brand"
                                    required
                                    :disabled="loading"
                                    :settings="selectizeConfig">
                                    <option :value="d.id" v-for="(d, i) in brands" :key="i"> {{d.nama_brand}}</option>
                                </selectize>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="supervisor" class="form-label">Nama Supervisor</label>
                                <selectize
                                    id="supervisor"
                                    @input="_getListTim"
                                    v-model="dataFilter.id_supervisor"
                                    data-placeholder="Pilih Nama Supervisor"
                                    required
                                    :disabled="loading"
                                    :settings="selectizeConfig">
                                    <option :value="d.id" v-for="(d, i) in supervisors" :key="i"> {{d.nama_sales_supervisor}}</option>
                                </selectize>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="tim" class="form-label">Tim</label>
                                <selectize
                                    id="tim"
                                    v-model="dataFilter.id_tim"
                                    data-placeholder="Pilih Tim"
                                    required
                                    :disabled="loading"
                                    :settings="selectizeConfig">
                                    <option :value="d.id" v-for="(d, i) in tims" :key="i"> {{d.nama_tim}}</option>
                                </selectize>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="minggu_awal" class="form-label">Minggu Awal</label>
                                <selectize
                                    id="minggu_awal"
                                    v-model="dataFilter.start_week"
                                    data-placeholder="Pilih Minggu Awal"
                                    required>
                                    <option :value="i" v-for="i in weeks" :key="i">Week {{i}}</option>
                                </selectize>
                            </div>

                            <div class="form-group col-md-6">
                                <label for="minggu_akhir" class="form-label">Minggu Akhir</label>
                                <selectize
                                    id="minggu_akhir"
                                    v-model="dataFilter.end_week"
                                    data-placeholder="Pilih Minggu Akhir"
                                    required>
                                    <option :value="i" v-for="i in weeks" :key="i">Week {{i}}</option>
                                </selectize>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="tahun_awal" class="form-label">Tahun Awal</label>
                                <selectize
                                    id="tahun_awal"
                                    v-model="dataFilter.start_year"
                                    data-placeholder="Pilih Tahun Awal"
                                    required>
                                    <option :value="i" v-for="i in years" :key="i">{{i}}</option>
                                </selectize>
                            </div>

                            <div class="form-group col-md-6">
                                <label for="tahun_akhir" class="form-label">Tahun Akhir</label>
                                <selectize
                                    id="tahun_akhir"
                                    v-model="dataFilter.end_year"
                                    data-placeholder="Pilih Tahun Akhir"
                                    required>
                                    <option :value="i" v-for="i in years" :key="i">{{i}}</option>
                                </selectize>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="jumlah-libur" class="form-label">Jumlah Libur</label>
                                <input id="jumlah-libur" type="number" class="form-control" required v-model="dataFilter.jumlah_libur" step="0.5">
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" @click="close()" v-html="'Tutup'" />
                            <button type="button" class="btn btn-primary" @click="submit" v-html="'OK'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

export default {
    name: "Modal",
    props: {
        config: {
            default: {
                view: false,
                title: "Modal Title"
            }
        },
        initData: null,
        isSubmit: {
            default: false
        },
        dismiss: {
            default: true
        }
    },

    mixins: [helper],

    data() {
        return {
            backdrop: false,
            modal: {
                open: false,
                formNav: 0
            },

            selectizeConfig: {
                maxItems: 99,
                plugins: ["remove_button"]
            },

            request: true,
            principals: [],
            brands: [],
            supervisors: [],
            tims: [],
            weeks: [],
            years: [],

            dataFilter: {
                id_principal: [],
                id_brand: [],
                id_supervisor: [],
                id_tim: [],
                start_week: 0,
                end_week: 0,
                start_year: '',
                end_year: '',
                jumlah_libur: 0,
            },
        };
    },

    computed: {
        ...mapState(['loading']),
    },

    methods: {
        ...mapActions('principal', ['getListPrincipal']),
        ...mapActions('brand', ['getListBrand']),
        ...mapActions('salesman', ['getListSalesmanSpv']),
        ...mapActions('tim', ['getTimBySpv']),
        close() {
            this.$emit("update:config", {
                view: false
            });
        },

        _getListPrincipal() {
            this.getListPrincipal({}).then( res => {
                this.principals = res
            })
        },

        _getListBrand() {
            this.getListBrand({filter: false, perPage: 'all', id_principal:this.dataFilter.id_principal}).then( res => {
                this.brands = res
            })
        },

        _getListSupervisor() {
            this.getListSalesmanSpv({}).then( res => {
                this.supervisors = res
            })
        },

        _getListTim() {
            this.getTimBySpv({ids_supervisor:this.dataFilter.id_supervisor}).then( res => {
                this.tims = res
            })
        },

        _getWeeks() {
            this.weeks = Array.from({ length: 52 }, (_, index) => index + 1)
        },

        _getYears() {
            const startYear = 2016;
            const currentYear = new Date().getFullYear();
            this.years = Array.from({ length: currentYear - (startYear - 1) }, (_, index) => startYear + index);
        },

        submit() {
            this.$emit("submit", this.dataFilter);
            this.close()
        }
    },

    watch: {
        "config.view": function (view) {
            if (view) {
                this.$emit("update:isSubmit", false);

                this.backdrop = view;
                setTimeout(() => {
                    this.modal.open = view;
                    if(this.principals.length == 0) this._getListPrincipal()
                    if(this.supervisors.length == 0) this._getListSupervisor()
                    if(this.weeks.length == 0) this._getWeeks()
                    if(this.years.length == 0) this._getYears()
                }, 100);
            } else {
                this.modal.open = view;

                setTimeout(() => {
                    this.backdrop = view;
                }, 100);
            }
        },

        initData: function (data) {},
    },

    mounted: function () {
        
    }
}
</script>